var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { CaseOperatorPageService } from '~/services/domain-service/case-operator-page.service';
import { PageService } from '~/utils/page.service';
import { SortService } from '~/utils/sort.service';
import { namespace } from "vuex-class";
var CollectionExecutionModule = namespace("collection-execution");
var OutgoingWarehousingHistory = /** @class */ (function (_super) {
    __extends(OutgoingWarehousingHistory, _super);
    function OutgoingWarehousingHistory() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            createTime: [],
            operatorRealName: '',
            warehouseChangeType: '',
            caseId: ''
        };
        _this.dataSet = [];
        return _this;
    }
    //获取电催行动历史
    OutgoingWarehousingHistory.prototype.refreshData = function () {
        var _this = this;
        var params = __assign({}, this.searchModel);
        params.caseId = this.caseId;
        params.createTimeMax = this.$filter.dateRanageFormat(this.searchModel.createTime).end;
        params.createTimeMin = this.$filter.dateRanageFormat(this.searchModel.createTime).start;
        delete params.createTime;
        this.caseOperatorPageService
            .queryWarehouseChangeRecords(params, this.pageService)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    OutgoingWarehousingHistory.prototype.activated = function () {
        this.refreshData();
    };
    __decorate([
        Dependencies(PageService)
    ], OutgoingWarehousingHistory.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], OutgoingWarehousingHistory.prototype, "sortService", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], OutgoingWarehousingHistory.prototype, "caseOperatorPageService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], OutgoingWarehousingHistory.prototype, "caseId", void 0);
    OutgoingWarehousingHistory = __decorate([
        Component({
            components: {},
        })
    ], OutgoingWarehousingHistory);
    return OutgoingWarehousingHistory;
}(Vue));
export default OutgoingWarehousingHistory;
